import { http } from '#utils/axios';

class TraderService {
  getClientInfo = async () => {
    const { data } = await http({
      url: `${this.endpoint}/`
    });
    return data;
  };

  getTraderProfileTransactions = async (params) => {
    const { data } = await http({
      method: 'GET',
      params,
      url: `/trader-profile-transactions`
    });

    return data;
  };

  updateProfile = async (data) => {
    const { data: result } = await http({
      data,
      method: 'PATCH',
      url: `${this.endpoint}`
    });
    return result;
  };

  getOptionsList = (params) => {
    return http({
      params,
      url: `${this.endpoint}/list`
    }).then(({ data }) => ({
      next: null,
      result: data?.map((el) => {
        return {
          label: el.name,
          value: el.id
        };
      })
    }));
  };

  constructor() {
    this.endpoint = '/trader-profile';
    if (!TraderService.instance) {
      TraderService.instance = this;
    }
    return TraderService.instance;
  }
}

const instance = new TraderService();
Object.freeze(instance);

export default instance;
